import qs from '../../scripts/util/DOM/qs';
import addClass from '../../scripts/util/DOM/addClass';
import bindEvent from '../../scripts/util/bindEvent';
import form from '../../scripts/form';
import $ from 'jquery';

const selectors = {
	body: 'body',
	button: 'a[href="#question-popup"]',
	popup: '.support__question-popup',
	page: '.page',
	close: '.support__question-popup-close-icon',
	form: '.support__question-popup-form',
	input: '.support__question-popup .js-field-input'
};

const classes = {
	open: 'support__question-popup_open',
	noscroll: 'noscroll',
	show: 'show',
	bodyHidden: 'body_hidden',
	pageHidden: 'page_state_hidden'
};

const page = qs(selectors.page);
let scrollPosition;

const removeClass = (cls, elem) => {
	elem.classList.remove(classes[cls]);
};

const clearForm = () => {
	qs(selectors.form).reset();
};

const hidePopup = () => {
	const popup = qs(selectors.popup);
	const response = qs('.send--response');

	removeClass('show', response);
	removeClass('noscroll', page);
	removeClass('open', popup);

	$(selectors.body).removeClass(classes.bodyHidden);
	$(selectors.page).removeClass(classes.pageHidden);
	$(window).scrollTop(scrollPosition);
	clearForm();
};

const showPopup = e => {
	e.preventDefault();
	const popup = qs(selectors.popup);
	scrollPosition = $(window).scrollTop();
	addClass(classes.noscroll)(page);
	addClass(classes.open)(popup);
	$(selectors.body).addClass(classes.bodyHidden);
	$(selectors.page).addClass(classes.pageHidden);
};

const closeByKey = e => {
	if (e.keyCode === 27) {
		hidePopup();
	}
};

const hidePlaceholders = () => {
	$(selectors.input).focus( function () {
		$(this).data('placeholder', $(this).attr('placeholder'));
		$(this).attr('placeholder', '');
	});
	$(selectors.input).blur( function () {
		$(this).attr('placeholder', $(this).data('placeholder'));
	});
};

const success = res => {
	$('.send--response').text($('.send--response').data(res.status));
	addClass('show')(qs('.send--response'));
	$(selectors.form).removeClass('disable-form');
	clearForm();
	setTimeout(hidePopup, 2000);
};

const render = () => {
	bindEvent(selectors.close, 'click', hidePopup);
	bindEvent(selectors.button, 'click', showPopup);
	window.addEventListener('keyup', closeByKey);
	const formBlock = qs(selectors.form);
	form(formBlock, success, '/have-question');
	hidePlaceholders();
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/support/question.js